// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__RpJug","ellipsis":"styles_ellipsis__ZNhOL","text2AndMoreLines":"styles_text2AndMoreLines__dMGd_","tooltipTrigger":"styles_tooltipTrigger__F1MJ5"};